// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"255":"32197162","787":"3399f4ff"}[chunkId] + ".chunk.js";
};